export default __webpack_public_path__ + "static/media/jinguyinhang.cb97b12e.png";